<template>
  <div>
    <div v-if="loading" class="vehicle-cameras-empty">
      <feather-icon icon="LoaderIcon" size="32" class="vehicle-cameras-spinner" />
      <p>{{ $t("Loading") }}...</p>
    </div>

    <div v-else-if="!device" class="vehicle-cameras-empty">
      <feather-icon icon="VideoOffIcon" size="32" />
      <p>{{ $t("Nenhuma câmera Hikvision vinculada a este veículo") }}</p>
    </div>

    <hik-camera-grid v-else :device-id="device.id" />
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "VehicleCameras",

  components: {
    // async: mantém o hls.js (~1.5MB) fora do bundle carregado em toda página
    HikCameraGrid: () => import("../../HikCamera/HikCameraGrid"),
  },

  props: {
    vehicleId: {
      type: [Number, String],
      required: true,
    },
  },

  data() {
    return {
      loading: false,
      device: null,
    };
  },

  created() {
    this.loadDevice();
  },

  methods: {
    async loadDevice() {
      this.loading = true;
      try {
        const response = await axios.get(
            `${this.$store.state.api}vehicles/${this.vehicleId}/hikvision-camera`
        );
        this.device = (response.data && response.data.data) || null;
      } catch (error) {
        this.$error(error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.vehicle-cameras-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.75rem;
  padding: 4rem 1rem;
  color: #6e6b7b;
  text-align: center;
}

.vehicle-cameras-spinner {
  animation: vehicle-cameras-spin 1s linear infinite;
}

@keyframes vehicle-cameras-spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}
</style>
